module.exports = __webpack_public_path__ + "img/spot7.63be0a1c.jpg";